<template>
  <div class="content employee-page">
    <div class="employee-toolbar row-data">
      <div class="employee-toolbar-card">
        <!-- Bộ lọc -->
        <div class="employee-toolbar-section employee-toolbar-section--filter">
          <div class="employee-card-head">
            <div>
              <p class="employee-card-title">Bộ lọc tìm kiếm</p>
              <p class="employee-card-subtitle">Tìm nhanh nhân sự theo trạng thái, phòng ban và thông tin liên hệ.</p>
            </div>
          </div>
          <div class="button-click-left employee-filter-grid">
            <!-- trạng thái đăng nhập -->
            <el-select
                class="employee-filter-control employee-filter-control--sm"
                v-model="dataSearch.loginStatus"
                @change="searchHeaderMethod()"
                clearable
                placeholder="Trạng thái"
            >
              <el-option
                  v-for="item in loginStatusList"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value"
              ></el-option>
            </el-select>
            <el-select
                class="button-left"
                v-model="dataSearch.statusEmployeee"
                @change="searchHeaderMethod()"
                placeholder="Trạng thái"
            >
              <el-option
                  v-for="item in statusEmployeeList"
                  :key="item"
                  :label="item"
                  :value="item"
              ></el-option>
            </el-select>

            <el-select
                class="button-left"
                v-model="dataSearch.idDepartment"
                @change="searchHeaderMethod()"
                placeholder="Phòng ban"
                clearable
            >
              <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.departmentName"
                  :value="item.id"
              ></el-option>
            </el-select>
            <el-input
                class="employee-search-input"
                placeholder="Nhập tên hoặc số điện thoại"
                v-model="dataSearch.employeeNameOrPhone"
                @keyup.enter.native="searchHeaderMethod()"
                clearable
                @clear="searchHeaderMethod()"
            >
              <template #append>
                <el-button
                    icon="el-icon-search"
                    @click="searchHeaderMethod()"
                ></el-button>
              </template>
            </el-input>
          </div>
        </div>

        <div class="employee-toolbar-divider"></div>

        <!-- Tác vụ nhanh -->
        <div class="employee-toolbar-section employee-toolbar-section--action">
          <div class="employee-card-head employee-card-head--compact">
            <div>
              <p class="employee-card-title">Tác vụ nhanh</p>
              <p class="employee-card-subtitle">Thêm mới, gửi tin và thao tác hàng loạt.</p>
            </div>
          </div>
          <div class="employee-action-group">
            <el-button
                v-if="checkPermission(['infoEmployee_list_update'])"
                class="button-over employee-action-button employee-action-button--primary"
                type="success"
                @click="createEmployeeDialog()"
            >
              <i class="el-icon-plus"/>
              Thêm mới
            </el-button>
            <el-dropdown
                v-if="
                checkPermission(['infoEmployee_list_app']) ||
                checkPermission(['infoEmployee_list_sms'])
              "
                @command="handleSendNotify"
            >
              <el-button class="button-over employee-action-button" type="success">
                Gửi tin
                <i class="el-icon-caret-bottom"/>
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item
                    v-if="checkPermission(['infoEmployee_list_app'])"
                    command="createNotifyApp"
                >Gửi qua App
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="checkPermission(['infoEmployee_list_sms'])"
                    command="createNotifySms"
                >Gửi qua SMS
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="checkPermission(['infoEmployee_list_sms'])"
                    command="sendAccount"
                >Gửi tài khoản
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="handleCommand">
              <el-button class="button-over employee-action-button" type="success">
                Tác vụ
                <i class="el-icon-caret-bottom"/>
              </el-button>
              <el-dropdown-menu>
                <span v-if="checkPermission(['infoEmployee_list_update'])">
                  <el-dropdown-item command="activeAccount">Kích hoạt App</el-dropdown-item>
                  <el-dropdown-item command="unactiveAccount">Hủy kích hoạt App</el-dropdown-item>
                  <el-dropdown-item command="activeSMS">Kích hoạt SMS</el-dropdown-item>
                  <el-dropdown-item command="unactiveSMS">Hủy kích hoạt SMS</el-dropdown-item>
                </span>
                <el-dropdown-item command="importExcel">Nhập File Excel</el-dropdown-item>
                <el-dropdown-item command="exportExcel">Xuất File Excel</el-dropdown-item>
                <el-dropdown-item v-if="deleteStatusButton" command="deleteMultiEmployee">Xóa nhân sự</el-dropdown-item>
                <el-dropdown-item command="groupOut">Ra trường</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- Bảng nhân sự -->
    <div class="employee-table-card row-data">
      <div class="employee-card-head employee-table-head">
        <div>
          <p class="employee-card-title">Danh sách nhân sự</p>
          <p class="employee-card-subtitle">Theo dõi thông tin, tài khoản, nhận diện AI và trạng thái làm việc.</p>
        </div>
        <div class="employee-summary-pill">
          <strong>{{ employeeDataList.length }}</strong>
          <span>/ {{ pageTotal }} bản ghi</span>
        </div>
      </div>
      <div class="table-content employee-table-wrapper">
        <el-table
            class="sk-table"
            :empty-text="textTable"
            v-loading="loadingData"
            :element-loading-text="$tableLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            :data="employeeDataList"
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionChange"
            :max-height="$tableMaxHeight"
            :cell-style="tableRowStyle"
            border
        >
        <el-table-column
            fixed
            type="selection"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column
            fixed
            type="index"
            label="STT"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column fixed prop="fullName" min-width="170" label="Họ tên">
          <template v-slot:default="scope">
            <el-button
                class="click-in-row"
                type="text"
                @click="clickFullName(scope.$index, scope.row)"
            >{{ scope.row.fullName }}
            </el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="Phòng ban" min-width="120">
          <template v-slot:default="scope">
            <div
                class="class-cell"
                @click="openDepartmentDialog(scope.row)"
            >
                    <span
                        class="class-text"
                        v-for="item in scope.row.departmentEmployeeList"
                        :key="item.department.id"
                    >- {{ item.department.departmentName }}
                    </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Lớp" min-width="120">
          <template v-slot:default="scope">
            <div
                @click="openClassDialog(scope.row)"
                class="class-cell"
            >
      <span
          class="class-text"
          v-for="item in scope.row.exEmployeeClassList"
          :key="item.maClass.id"
      >
        - {{ item.maClass.className }}<span v-if="item.master"> - CN</span>
      </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="birthday" label="Ngày sinh" align="center" min-width="120">
          <template v-slot:default="scope">
            <span>{{ scope.row.birthday | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="gender"
            label="Giới tính"
            min-width="80"
            align="center"
        ></el-table-column>
        <el-table-column label="SMS" align="center" width="70">
          <template v-slot:default="scope">
            <el-checkbox
                :disabled="!checkPermission(['infoEmployee_list_update'])"
                @change="activeOneSMSMethod(scope.row)"
                v-model="scope.row.smsReceive"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            label="Kích hoạt"
            align="center"
            width="80">
          <template v-slot:default="scope">
            <el-checkbox
                :disabled="!checkPermission(['infoEmployee_list_update'])
                || dataSearch.statusEmployeee === 'Nghỉ làm'"
                @change="activeOneMethod(scope.row)"
                v-model="scope.row.activated"

            ></el-checkbox>
            <el-tooltip
                v-if="scope.row.login"
                effect="dark"
                content="Đã đăng nhập"
                placement="top"
            >
              <i class="el-icon-circle-check" style="margin-left: 10px; color: #409eff"/>
            </el-tooltip>
            <el-tooltip v-else effect="dark" content="Chưa đăng nhập" placement="top">
              <i class="el-icon-circle-check" style="margin-left: 10px; color: red"/>
            </el-tooltip>
          </template>
          <!--          <i style="color: #78a5e7; margin-left: 10px" class="el-icon-success"/>-->
        </el-table-column>

        <el-table-column
            prop="phone"
            label="SĐT"
            width="120"
            align="center"
        ></el-table-column>
        <el-table-column label="SĐT-SMS" align="center" width="100">
          <template v-slot:default="scope">
            <el-tooltip content="Đổi số điện thoại nhận SMS" placement="top">
              <el-button
                  class="click-in-row"
                  @click="changePhoneSMSDialogMethod(scope.row)"
                  type="text"
                  size="mini"
              >
                <span>{{ scope.row.phoneSMS }}</span>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="Tài khoản" width="120" align="center">
          <template v-slot:default="scope">
            <span v-if="scope.row.username === ''">
              <el-button
                  class="handle-account"
                  @click="accountHanedleDialogMethod(scope.row)"
                  type="text"
                  size="mini"
              >
                <span>&#8810;Xử lý&#8811;</span>
              </el-button>
            </span>
            <span v-else>
              <el-tooltip :content="'Mật khẩu: ' + scope.row.password" placement="top">
                <span>{{ scope.row.username }}</span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="airecognitionDataExists" width="100" label="Nhận diện AI" align="center">
          <template v-slot:default="scope">
            <div
                :class="['status-icon', scope.row.airecognitionDataExists ? 'success' : 'fail']"
            ></div>
          </template>
        </el-table-column>
        <el-table-column
            label="Tác vụ"
            align="center"
            fixed="right"
            :width="checkPermission(['infoEmployee_list_update']) ? (deleteStatusButton ? 330 : 255) : 100"
        >
          <template v-slot:default="scope">
            <el-button
                v-if="checkPermission(['infoEmployee_list_update'])"
                size="mini"
                type="success"
                @click="handleEdit(scope.$index, scope.row)"
            >Sửa
            </el-button>
            <el-button
                v-if="checkPermission(['infoEmployee_list_update'])"
                :disabled="dataSearch.statusEmployeee === 'Nghỉ làm'"
                size="mini"
                type="primary"
                @click="updateEmployeeStatusMethod(scope.row)"
            >Nghỉ làm
            </el-button>
            <el-button
                size="mini"
                type="info"
                @click="openEmployeeHistory(scope.row)"
            >Lịch sử
            </el-button>
            <el-button
                v-if="checkPermission(['infoEmployee_list_update']) && deleteStatusButton"
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
            >Xóa
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>
    <div class="container_nav_page">
      <el-pagination
          background
          :current-page="pageNumber"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="$pageListDefaultUser"
          :page-size="maxPageItem"
          :layout="$pageLayoutDefault"
          :total="pageTotal"
      ></el-pagination>
    </div>
    <InformationClassByEmployeeDialog
        :classDialogVisible="classDialogVisible"
        :selectedClassList="selectedClassList"
        @dialog-close="closeInformationClassByEmployeeDialog()"
    />
    <InformationDepartmentByEmployeeDialog
        :departmentDialogVisible="departmentDialogVisible"
        :selectedDepartmentList="selectedDepartmentList"
        @dialog-close="closeInformationDepartmentByEmployeeDialog()"
    />
    <EmployeeLifecycleDialog
        :dialogVisible="showEmployeeHistoryDialog"
        :employee="historyEmployee"
        @dialog-close="closeEmployeeHistory"
    />
    <CreateEmployee
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
        ref="CreateEmployee"
    />
    <UpdateEmployee
        :dialogVisible="showUpdateDialog"
        @dialog-close="dialogCloseUpdateMethod()"
        ref="UpdateEmployee"
    />
    <CreateEmployeeNotify
        v-bind:dataEmployeeNotifyList="dataEmployeeNotifyList"
        :dialogVisibleEx="showCreateNotifyDialog"
        @dialog-close="dialogCloseCreateNotifyMethod()"
        ref="CreateStudentNotify"
    />
    <CreateEmployeeNotifySms
        v-bind:dataEmployeeNotifySmsList="dataEmployeeNotifySmsList"
        :dialogVisibleSms="showCreateNotifySmsDialog"
        @dialog-close="dialogCloseCreateNotifySmsMethod()"
        ref="CreateEmployeeNotifySms"
    />
    <CreateEmployeeExcel
        :dialogVisibleExEmployee="showCreateExcelDialog"
        @dialog-close="dialogCloseCreateExcelMethod()"
        ref="CreateEmployeeExcel"
    />
    <AccountHandle
        :dialogVisible="showAccountHandeDialog"
        @dialog-close="dialogCloseAccountHandleMethod()"
        ref="AccountHandle"
    />
    <ChangePhoneSMS
        :dialogVisible="showChangePhoneSMSDialog"
        @dialog-close="dialogCloseChangePhoneSMSMethod()"
        ref="ChangePhoneSMS"
    />
    <EmployeeUpdateStatusDialog
        :dialogVisible="showUpdateEmployeeStatus"
        @dialog-close="closeUpdateEmployeeStatus()"
        ref="EmployeeUpdateStatusDialog"
    />
    <CreateSmsDialog
        :dialogVisible="showCreateSms"
        @dialog-close="closeCreateSmsMethod()"
        ref="CreateSmsDialog"
    />
    <CreateEmployeeGroupOutDialog
        :listEmployee="multipleSelection"
        :dialogVisible="showCreateGroupOutDialog"
        @dialog-close="closeCreateGroupOutDialog()"
        ref="CreateEmployeeGroupOutDialog"
    />
  </div>
</template>

<script>
// import http from "../../http-download";
import moment from "moment";
import checkPermission from "@/utils/permission.js";
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";
import CreateEmployee from "./CreateEmployee.vue";
import UpdateEmployee from "./UpdateEmployee.vue";
import CreateEmployeeNotify from "./CreateEmployeeNotify.vue";
import CreateEmployeeNotifySms from "./CreateEmployeeNotifySms.vue";
import CreateEmployeeExcel from "./CreateEmployeeExcel.vue";
import AccountHandle from "@/views/common/AccountHandle.vue";
import ChangePhoneSMS from "@/views/common/ChangePhoneSMS.vue";
import EmployeeUpdateStatusDialog from "./EmployeeUpdateStatusDialog.vue";
import CreateEmployeeGroupOutDialog from "./CreateEmployeeGroupOutDialog.vue";
import CreateSmsDialog from "../common/CreateSmsDialog.vue";
import {statusEmployeeList} from "@/constant/listCommon";
import {mapGetters} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import InformationClassByEmployeeDialog from "@/views/employee/InformationClassByEmployeeDialog.vue";
import InformationDepartmentByEmployeeDialog from "@/views/employee/InformationDepartmentByEmployeeDialog.vue";
import EmployeeLifecycleDialog from "./EmployeeLifecycleDialog.vue";

export default {
  components: {
    InformationDepartmentByEmployeeDialog,
    InformationClassByEmployeeDialog,
    EmployeeLifecycleDialog,
    CreateEmployee,
    UpdateEmployee,
    CreateEmployeeNotify,
    CreateEmployeeNotifySms,
    CreateEmployeeExcel,
    AccountHandle,
    ChangePhoneSMS,
    EmployeeUpdateStatusDialog,
    CreateSmsDialog,
    CreateEmployeeGroupOutDialog,
  },
  data() {
    return {
      loadingData: true,
      textTable: "",
      pageTotal: this.$pageTotalDefault,
      maxPageItem: this.$pageSizeDefaultNew,
      pageNumber: 1,
      deleteStatusButton: false,
      employeeDataList: [],
      multipleSelection: [],
      showCreateDialog: false,
      showUpdateDialog: false,
      showCreateNotifyDialog: false,
      showCreateNotifySmsDialog: false,
      showCreateExcelDialog: false,
      showAccountHandeDialog: false,
      showChangePhoneSMSDialog: false,
      showUpdateEmployeeStatus: false,
      showCreateGroupOutDialog: false,
      showCreateSms: false,
      loading: "",
      loginStatusList: [
        {key: false, value: "Chưa đăng nhập"},
        {key: true, value: "Đã đăng nhập"},
      ],
      statusEmployeeList,
      dataListNotify: [],
      dataListNotifySms: [],
      dataEmployeeNotifyList: [],
      dataEmployeeNotifySmsList: {
        listId: [],
        listNoActive: [],
      },
      fixpage: 1,
      fixpagenumber: 10,
      idList: [],
      updateSelectedActivated: {
        updateEmployeeMainInfoRequest: {
          activated: "",
          id: "",
        },
      },
      dataSearch: {
        loginStatus: "",
        statusEmployeee: "Đang làm",
        idDepartment: "",
        employeeNameOrPhone: "",
      },
      //css excel
      styleCols1: [],
      styleCols2: [],
      classDialogVisible: false,
      departmentDialogVisible: false,
      selectedClassList: [],
      selectedDepartmentList: [],
      showEmployeeHistoryDialog: false,
      historyEmployee: null,
    };
  },
  computed: {
    ...mapGetters('departmentStore', ['departmentList']),
  },
  methods: {
    openEmployeeHistory(row) {
      this.historyEmployee = row;
      this.showEmployeeHistoryDialog = true;
    },
    closeEmployeeHistory() {
      this.showEmployeeHistoryDialog = false;
      this.historyEmployee = null;
    },
    openClassDialog(row) {
      this.selectedClassList = row.exEmployeeClassList || [];
      this.classDialogVisible = true;
    },
    openDepartmentDialog(row){
      this.selectedDepartmentList = row.departmentEmployeeList || [];
      this.departmentDialogVisible = true;
    },
    closeInformationClassByEmployeeDialog(){
      this.classDialogVisible = false;
    },
    closeInformationDepartmentByEmployeeDialog(){
      this.departmentDialogVisible = false;
    },
    getDepartments() {
      this.$store.dispatch('departmentStore/fetchDataDepartmentList');
    },
    checkPermission,
    dialogCloseCreateNotifySmsMethod() {
      this.showCreateNotifySmsDialog = false;
      // this.fetchDataMany();
      location.reload();
      this.dataEmployeeNotifySmsList = [];
      this.dataEmployeeNotifySmsList.listId = [];
      this.dataEmployeeNotifySmsList.listNoActive = [];
    },
    dialogCloseCreateExcelMethod() {
      this.showCreateExcelDialog = false;
      this.searchByProperties();
    },
    createSmsMethod() {
      this.showCreateSms = true;
      let idList = this.multipleSelection.map((x) => x.id);
      this.$refs.CreateSmsDialog.getDataCreateSmsInitial(idList, "employee", "employee");
    },
    closeCreateSmsMethod() {
      this.showCreateSms = false;
    },
    // xuất file excel
    exportExcelEmployee() {
      let list = [];
      this.multipleSelection.forEach((x) => list.push(x.id));
      if (list.length === 0) {
        this.$message({
          message: "Không có nhân viên nào được chọn",
          type: "error",
        });
        return;
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        this.getStyleExcelEmployee();
        let myDate = moment(new Date()).format("DD-MM-YYYY hh:mm:ss");

        EmployeeDataService.exportExcelEmployeeNew(list)
            .then((resp) => {
              import("@/services/ExportExcel")
                  .then((excel) => {
                    let dataList = resp.data.data;
                    let fileName = `QUAN_LY_NHAN_SU_${myDate}`;
                    const tHeader = [
                      "STT",
                      "Tình trạng",
                      "Họ và tên",
                      "Ngày sinh",
                      "Giới tính",
                      "TK/SĐT",
                      "Ngày vào",
                      "Ngày ký HĐ",
                      "Ngày hết hạn HĐ",
                      "Email",
                      "Số CMND",
                      "Ngày cấp",
                      "Địa chỉ thường chú",
                      "Chỗ ở hiện tại",
                      "Hôn nhân",
                      "Số con",
                      "Trình độ",
                      "Chuyên môn",
                      "Phòng ban",
                      "Lớp quản lý",
                      "Đối tượng",
                      "Tên ngân hàng",
                      "Số tài khoản",
                      "Ghi chú",
                    ];
                    const filterVal = [
                      "pro1",
                      "pro2",
                      "pro3",
                      "pro4",
                      "pro5",
                      "pro6",
                      "pro7",
                      "pro8",
                      "pro9",
                      "pro10",
                      "pro11",
                      "pro12",
                      "pro13",
                      "pro14",
                      "pro15",
                      "pro16",
                      "pro17",
                      "pro18",
                      "pro19",
                      "pro20",
                      "pro21",
                      "pro22",
                      "pro23",
                      "pro24",
                    ];
                    let columnList = [
                      {col: 5},
                      {col: 15},
                      {col: 25},
                      {col: 15},
                      {col: 10},
                      {col: 15},
                      {col: 15},
                      {col: 15},
                      {col: 15},
                      {col: 25},
                      {col: 15},
                      {col: 15},
                      {col: 30},
                      {col: 30},
                      {col: 10},
                      {col: 5},
                      {col: 15},
                      {col: 15},
                      {col: 15},
                      {col: 25},
                      {col: 15},
                      {col: 25},
                      {col: 25},
                      {col: 25},
                    ];
                    excel.export_json_to_excel({
                      header: tHeader,
                      data: dataList,
                      title: filterVal,
                      filename: fileName,
                      columnsWidth: columnList,
                      styleCols1: this.styleCols1,
                      styleCols2: this.styleCols2,
                    });
                  })
                  .finally(() => {
                    this.styleCols1 = [];
                    this.styleCols2 = [];
                  });
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Thất bại",
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingExcel = false;
              }, 500);
            });
      });
    },
    getStyleExcelEmployee() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      let styleCol1 = {
        name: "A5:X5",
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font,
          alignment,
          border,
        },
      };
      //style1
      let styleCol2 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
        },
      };
      let styleCol3 = {
        name: ["A2", "A3", "A4"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };
      this.styleCols2.push(styleCol1);

      this.styleCols1.push(styleCol2);
      this.styleCols1.push(styleCol3);
    },
    // Nhập file excel
    importExcelEmployee() {
      this.showCreateExcelDialog = true;
    },
    // CREATE NOTIFY
    handleSendNotify(command) {
      let employeeList = this.multipleSelection;
      if (employeeList.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có nhận sự nào được chọn");
        return;
      } else if (employeeList.length > 1000) {
        NotifyMessage.leftCornerNotificationError("Bạn không thể gửi vượt quá 1000 nhân viên/lần gửi");
        return;
      }
      switch (command) {
        case "createNotifyApp":
          this.createNotifyDialog(employeeList);
          break;
        case "createNotifySms":
          this.createSmsMethod(employeeList);
          break;
        case "sendAccount":
          this.sendAccount(employeeList);
          break;
      }

    },
    sendAccount() {
      let list = [];
      this.multipleSelection.forEach((x) => list.push(x.id));
      if (list.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có nhận sự nào được chọn");
        return;
      } else if (list.length > 1000) {
        NotifyMessage.leftCornerNotificationError("Bạn không thể gửi vượt quá 1000 nhân viên/lần gửi");
        return;
      }
      this.$confirm(
          "Bạn có chắc chắn muốn gửi tài khoản cho nhân viên đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.openFullScreen2();
        EmployeeDataService.sendAccountEmployee(list)
            .then((response) => {
              this.loading.close();
              this.$message({
                message: response.data.message,
                type: "success",
              });
              this.searchByProperties();
            })
            .catch((err) => {
              this.loading.close();
              console.log(err);
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
      });
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "Tài khoản đang được gửi. Xin vui lòng chờ trong giây lát!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

    },
    createNotifyDialog(data) {

      this.dataEmployeeNotifyList = data.map((x) => x.id);
      this.showCreateNotifyDialog = true;
    },

    createNotifySmsDialog(data) {
      this.dataListNotifySms = data;
      console.log(this.dataListNotifySms);

      this.dataListNotifySms.forEach((value) => {
        this.dataEmployeeNotifySmsList.listId.push(value.id);
        if (value.smsReceive === false) {
          this.dataEmployeeNotifySmsList.listNoActive.push(value.id);
        }
      });
      console.log(this.dataEmployeeNotifySmsList);
      this.showCreateNotifySmsDialog = true;
      this.$refs.CreateEmployeeNotifySms.getNumber();
    },
    dialogCloseCreateNotifyMethod() {
      this.showCreateNotifyDialog = false;
    },
    //
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    // highlight cho row theo điều kiện
    tableRowStyle({row}) {
      if (row.phoneSMS === "") {
        return "color: red";
      }
    },
    // click chọn số bản ghi trên 1 trang
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.searchByProperties();
    },
    //click chọn số trang
    handleCurrentChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    handleCommand(command) {
      if (command === "importExcel") {
        this.importExcelEmployee();
      } else {
        let dataList = this.multipleSelection;
        if (dataList.length === 0) {
          this.$message({
            message: "Chưa có nhân viên nào được chọn",
            type: "error",
          });
          return;
        }
        let idList = dataList.map((x) => x.id);
        if (command === "activeAccount") {
          this.updateMultiActivated(idList, true);
        } else if (command === "unactiveAccount") {
          this.updateMultiActivated(idList, false);
        } else if (command === "activeSMS") {
          this.updateMultiActivatedSMS(idList, true);
        } else if (command === "unactiveSMS") {
          this.updateMultiActivatedSMS(idList, false);
        } else if (command === "deleteMultiEmployee") {
          this.handleMultiDelelte();
        } else if (command === "exportExcel") {
          this.exportExcelEmployee();
        } else if (command === "groupOut") {
          this.handelGroupOut();
        }
      }
    },
    accountHanedleDialogMethod(row) {
      let objectData = {
        id: row.id,
        appType: "teacher",
        phone: row.phone,
      };
      this.showAccountHandeDialog = true;
      this.$refs.AccountHandle.getAccountHandelInitial(objectData);
    },
    changePhoneSMSDialogMethod(row) {
      let objectData = {
        id: row.id,
        appType: "teacher",
        oldPhone: row.phoneSMS,
      };
      this.showChangePhoneSMSDialog = true;
      this.$refs.ChangePhoneSMS.getChangePhoneSMSInitial(objectData);
    },
    updateEmployeeStatusMethod(row) {
      this.showUpdateEmployeeStatus = true;
      this.$refs.EmployeeUpdateStatusDialog.getStatusDataInitial(row.id, row.fullName);
    },
    dialogCloseAccountHandleMethod() {
      this.showAccountHandeDialog = false;
      this.searchByProperties();
    },
    dialogCloseChangePhoneSMSMethod() {
      this.showChangePhoneSMSDialog = false;
      this.searchByProperties();
    },
    closeUpdateEmployeeStatus() {
      this.showUpdateEmployeeStatus = false;
      this.searchByProperties();
    },
    closeCreateGroupOutDialog() {
      this.searchByProperties();
      this.showCreateGroupOutDialog = false;
    },
    /**
     * Chuyển đồi học sinh ra trường
     */
    handelGroupOut() {
      this.showCreateGroupOutDialog = true;
    },
    //click checkbox of row
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //click edit at row
    handleEdit(index, row) {
      this.total = 1;
      this.handleCurrentChangeAfter();
      this.showUpdateDialog = true;
      this.$refs.UpdateEmployee.clickNameInitial("noFullName");
      this.$refs.UpdateEmployee.getEmployeeById(row.id);
      this.$refs.UpdateEmployee.getAllAccountType();
      this.$refs.UpdateEmployee.getTabDepartmentInEmployee();
      this.$refs.UpdateEmployee.getTabProfessionalInEmployee();
      this.$refs.UpdateEmployee.tabTeacherIconMethod(row.id);
      this.$refs.UpdateEmployee.getListCamera(row.id);
      this.$refs.UpdateEmployee.innitDataRecognition();
    },
    handleCurrentChangeAfter() {
      this.handleCurrentChange(1);
    },
    clickFullName(index, row) {
      this.showUpdateDialog = true;
      this.$refs.UpdateEmployee.clickNameInitial("fullName");
      this.$refs.UpdateEmployee.getEmployeeById(row.id);
      this.$refs.UpdateEmployee.getAllAccountType();
      this.$refs.UpdateEmployee.getTabDepartmentInEmployee();
      this.$refs.UpdateEmployee.getTabProfessionalInEmployee();
      this.$refs.UpdateEmployee.tabTeacherIconMethod(row.id);
      this.$refs.UpdateEmployee.getListCamera(row.id);
    },
    handleDelete(index, row) {
      this.$confirm(
          "Thao tác này sẽ xóa toàn bộ thông tin của nhân sự bao gồm cả thông tin tài chính. Bạn có chắc chắn muốn xóa nhân viên đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        EmployeeDataService.delete(row.id)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.searchByProperties();
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
      });
    },
    handleMultiDelelte() {
      let idList = [];
      this.multipleSelection.forEach((x) => idList.push(x.id));
      this.$confirm(
          "Thao tác này sẽ xóa toàn bộ thông tin của nhân sự bao gồm cả thông tin tài chính, Bạn có chắc chắn muốn xóa các nhân viên đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        EmployeeDataService.deleteMulti(idList)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.searchByProperties();
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
      });
    },
    createEmployeeDialog() {
      this.total = 1;
      this.showCreateDialog = true;
      this.$refs.CreateEmployee.getAllAccountType();
      this.$refs.CreateEmployee.getTabDepartmentInEmployee();
      this.$refs.CreateEmployee.getTabProfessionalInEmployee();
      this.$refs.CreateEmployee.tabTeacherIconMethod();
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
      this.searchByProperties();
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchByProperties();
    },
    searchHeaderMethod() {
      this.pageNumber = 1;
      this.searchByProperties();
    },
    searchByProperties() {
      this.loadingData = true;
      this.textTable = "";
      EmployeeDataService.searchEmployeeInSchool(
          this.pageNumber,
          this.maxPageItem,
          this.dataSearch.loginStatus,
          this.dataSearch.statusEmployeee,
          this.dataSearch.idDepartment,
          this.dataSearch.employeeNameOrPhone
      )
          .then((resp) => {
            this.employeeDataList = resp.data.data.dataList;
            this.pageTotal = resp.data.data.total;
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.studentList = [];
            console.log(err);
          })
          .finally(() => {
            if (this.employeeDataList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
      this.getDepartments();
    },
    /**
     * lưu kích hoạt/hủy kích hoạt tài khoản 1 người
     */
    activeOneMethod(row) {
      EmployeeDataService.updateActiveOne(row)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    /**
     * lưu kích hoạt/hủy kích hoạt sms 1 người
     */
    activeOneSMSMethod(row) {
      EmployeeDataService.updateActiveOneSMSReceive(row)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    /**
     * lưu kích hoạt/hủy kích hoạt app nhiều người
     */
    updateMultiActivated(idList, status) {
      let inputData = {
        idList: idList,
        status: status,
      };
      EmployeeDataService.updateActiveMany(inputData)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            this.searchByProperties();
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    /**
     * lưu kích hoạt/hủy kích hoạt sms nhiều người
     */
    updateMultiActivatedSMS(idList, status) {
      let inputData = {
        idList: idList,
        status: status,
      };
      EmployeeDataService.updateActiveManySMS(inputData)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            this.searchByProperties();
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    // getDepartment() {
    //   DepartmentDataService.getAllCommon()
    //       .then((response) => {
    //         this.departmentList = response.data.data;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // },
    async getSchoolConfigAddMethod() {
      await CommonOnekidsService.getSchoolConfigAdd()
          .then((resp) => {
            this.deleteStatusButton = resp.data.data.deleteStatus;
          })
          .catch((err) => {
            throw err;
          });
    },
    /**
     * get data initial
     */
    async fetchDataMany() {

      await Promise.all([this.getSchoolConfigAddMethod()])
          .then(() => {
            this.searchByProperties();
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },

  beforeMount() {
    this.fetchDataMany();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

.container_nav_page {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

/deep/ .el-pagination .el-select .el-input {
  width: 75px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

/deep/ .el-icon-loading:before {
  content: "\e6cf";
}

/deep/ .el-loading-spinner .el-loading-text {
  color: #606266;
  font-size: 15px;
}

/deep/ .el-loading-spinner {
  top: 67%;
  width: 100%;
  text-align: center;
  position: absolute;
}

/deep/ body .el-dropdown-menu,
/deep/ .el-dropdown-menu {
  padding: 6px 0;
  margin: 6px 0;
  background-color: #ffffff;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.12);
}

/deep/ body .el-dropdown-menu li,
/deep/ .el-dropdown-menu li {
  color: #334155;
  border-top: none;
  font-family: Inter, Arial, Helvetica, sans-serif;
}

/deep/ body .el-dropdown-menu__item:focus,
/deep/ body .el-dropdown-menu__item:not(.is-disabled):hover,
/deep/ .el-dropdown-menu__item:focus,
/deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
  background: #eff6ff;
  color: #2563eb;
}

.class-cell {
  cursor: pointer;
  color: #409EFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}

.class-text {
  display: inline;
}

/* ===== Employee Page Layout ===== */
.employee-page {
  padding: 4px 0 10px;

  .row-data {
    margin-bottom: 20px;
  }

  .button-left {
    width: 145px;
  }

  .button-click-left,
  .button-click {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .button-over {
    margin-left: 0;
  }
}

.employee-toolbar {
  display: block;
}

.employee-toolbar-card,
.employee-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.employee-toolbar-card {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px;
}

.employee-toolbar-section {
  min-width: 0;
}

.employee-toolbar-section--filter {
  flex: 1.6;
}

.employee-toolbar-section--action {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.employee-toolbar-divider {
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin: 0 20px;
  flex-shrink: 0;
}

.employee-table-card {
  padding: 18px 18px 12px;
}

.employee-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.employee-card-head--compact {
  margin-bottom: 14px;
}

.employee-card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.employee-card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.employee-filter-grid {
  align-items: center;
}

.employee-filter-control {
  width: 150px;
}

.employee-filter-control--sm {
  width: 150px;
}

.employee-search-input {
  width: 280px;
}

.employee-action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.employee-action-button {
  min-width: 120px;
  border-radius: 12px;
  font-weight: 600;
}

.employee-action-button--primary {
  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.18);
}

.employee-table-head {
  align-items: center;
}

.employee-summary-pill {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.employee-summary-pill strong {
  font-size: 18px;
  line-height: 1;
}

.employee-table-wrapper {
  border-radius: 16px;
  overflow: hidden;
}

/deep/ .employee-page .el-input__inner,
/deep/ .employee-page .el-select .el-input__inner {
  border-radius: 12px;
}

/deep/ .employee-page .el-button {
  border-radius: 12px;
}

/deep/ .employee-page .el-input-group__append .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}


@media (max-width: 1280px) {
  .employee-toolbar-card {
    flex-direction: column;
    align-items: stretch;
  }

  .employee-toolbar-divider {
    display: none;
  }

  .employee-table-head {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .employee-filter-grid,
  .employee-action-group {
    flex-direction: column;
    align-items: stretch;
  }

  .employee-filter-control,
  .employee-filter-control--sm,
  .button-left,
  .employee-search-input,
  .employee-action-button {
    width: 100%;
  }

  .employee-summary-pill {
    width: 100%;
    justify-content: center;
  }
}
</style>
